import {
    RESET_WALLET_LIMIT,
    UPDATE_PAYMENT_DATA,
    UPDATE_WALLET_LIMIT,
    UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE,
    UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE,
    UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION,
    UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE,
    UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY,
    WalletSwitchOffLimitPopupAction
} from '../actions/walletSwitchOffLimitEditPopup';
import { Tld } from '../typings/common';
import { CurrencyCode } from '../typings/graphql-log';
import { WalletSwitchOffLimitPopupState } from '../typings/walletState';

export const getWalletSwitchOffLimitEditPopupInitialState = (): WalletSwitchOffLimitPopupState => ({
    tld: Tld.ru,
    value: {
        sum: undefined,
        payerId: undefined,
        paymentMethodId: undefined
    },
    isVisible: false,
    isSaving: false,
    isResetting: false,
    currency: CurrencyCode.RUB,
    login: '',
    minSum: 0,
    maxSum: 0,
    canResetLimit: false
});

export function walletSwitchOffLimitPopup(
    state: WalletSwitchOffLimitPopupState = getWalletSwitchOffLimitEditPopupInitialState(),
    action: WalletSwitchOffLimitPopupAction
): WalletSwitchOffLimitPopupState {
    switch (action.type) {
        case UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY: {
            return {
                ...state,
                isVisible: action.isVisible
            };
        }

        case UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE: {
            if (
                state.paymentData &&
                action.value.payerId !== state.value.payerId &&
                state.value.payerId !== undefined &&
                action.value.paymentMethodId !== undefined
            ) {
                action.value.paymentMethodId = state.paymentData.paymentMethods[action.value.payerId as string][0].id;
            }

            return {
                ...state,
                value: {
                    ...state.value,
                    ...action.value
                },
                validationResult: undefined
            };
        }

        case UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE: {
            return {
                ...state,
                isSaving: action.isSaving
            };
        }

        case UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE: {
            return {
                ...state,
                isResetting: action.isResetting
            };
        }

        case UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION: {
            return {
                ...state,
                validationResult: action.validationResult
            };
        }

        case UPDATE_PAYMENT_DATA: {
            return {
                ...state,
                paymentData: action.paymentData
            };
        }

        case UPDATE_WALLET_LIMIT: {
            return {
                ...state,
                isVisible: false,
                isSaving: false
            };
        }

        case RESET_WALLET_LIMIT: {
            return {
                ...state,
                value: {
                    ...state.value,
                    sum: action.sum
                },
                isVisible: false,
                isResetting: false
            };
        }

        default:
            return state;
    }
}
